export default "__VITE_ASSET__C3fcO_xs__"